import { render, staticRenderFns } from "./KgjtWebsiteExperts.vue?vue&type=template&id=74b91832&scoped=true&"
import script from "./KgjtWebsiteExperts.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteExperts.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteExperts.vue?vue&type=style&index=0&id=74b91832&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b91832",
  null
  
)

export default component.exports